import React, { useEffect, useState } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import axios from "axios";
import "./payment.scss";
import { useNavigate } from "react-router-dom";
import { GoShieldCheck } from "react-icons/go";
import { SlLock } from "react-icons/sl";
import { BiSolidLock } from "react-icons/bi";

const InstantPaymentForm = ({
  onSuccess,
  amount,
  hanldPlaceOrder,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [cardError, setCardError] = useState("");
  const [success, setSuccess] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) return;

    const cardElement = elements.getElement(CardElement);
    if (!cardElement) {
      alert("Card element not found.");
      return;
    }

    setLoading(true);

    try {
      // ✅ Step 1: Place the order and get back orderId
      const orderRes = await hanldPlaceOrder(); // must return { orderId }
      const orderId = orderRes.data?.data?.orderId;
      // ✅ Step 2: Create payment intent linked to order
      const response = await axios.post("/create-payment-intent", {
        orderId,
        amount: orderRes.data?.data?.totalAmount,
      });
      const clientSecret = response.data.clientSecret;
      // ✅ Step 3: Confirm payment with Stripe
      const { error, paymentIntent } = await stripe.confirmCardPayment(
        clientSecret,
        {
          payment_method: {
            card: cardElement,
            billing_details: {
              name,
              email,
            },
          },
        }
      );

      if (error) {
        setCardError(error.message);
      } else if (paymentIntent && paymentIntent.status === "succeeded") {
        setSuccess("Payment completed successfully.");

        // ✅ Step 4: Save payment info in backend
        await axios.post(`/save-payment/${orderId}`, {
          paymentIntentId: paymentIntent.id,
          paymentMethodId: paymentIntent.payment_method,
          paymentStatus: "Paid",
        });

        if (onSuccess) onSuccess();
        navigate(`/complete?OrderId=${orderId}}`);
      }
    } catch (err) {
      console.error("Payment error", err);
      setCardError("Payment failed. Try again.");
    }

    setLoading(false);
  };


  return (
    <form className="ch_from" onSubmit={handleSubmit}>
      <div className="pay_hd">
        <div className="pr_wp">
          <h3>AED {amount}</h3>
        </div>
        <div>
          <div className="pay_meth">
            <img src={require("../../img/_pay.jpg")} alt="" />
          </div>
        </div>
      </div>
      <div className="check_out_hd">
        <div className="in_wrp">
          <strong>*Name on Card:</strong>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
      </div>
      <div className="in_wrp">
        <strong>*Card Details</strong>
      </div>
      <div id="card-element-wrapper">
        <div id="card-element">
          <CardElement
            options={{
              style: {
                base: {
                  border: "#000000",
                  iconColor: "#000000",
                  color: "#000000",
                  fontWeight: "500",
                  fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
                  fontSize: "18px",
                  fontSmoothing: "antialiased",
                  height: "100px",

                  ":-webkit-autofill": {
                    color: "#000000",
                  },
                  "::placeholder": {
                    color: "#000000",
                  },
                },
                invalid: {
                  iconColor: "#000000",
                  color: "#000000",
                },
              },
            }}
          />
        </div>
      </div>

      <div style={{ marginTop: "30px" }}>
        {loading ? (
          <>
            <button
              style={{
                zIndex: "999999",
                cursor: "pointer",
                marginTop: ".5rem",
                backgroundColor: "#0570de",
                color: "#fff",
                padding: "12px 20px",
                fontSize: "16px",
                border: "none",
                borderRadius: "4px",
                transition: "opacity 0.2s ease",
              }}
            >
              Payment in progress... Please wait
            </button>
          </>
        ) : (
          <button
            type="submit"
            disabled={!stripe}
            style={{
              zIndex: "999999",
              cursor: "pointer",
              marginTop: ".5rem",
              backgroundColor: "#0570de",
              color: "#fff",
              padding: "12px 20px",
              fontSize: "16px",
              border: "none",
              borderRadius: "4px",
              opacity: !stripe ? 0.5 : 1,
              transition: "opacity 0.2s ease",
            }}
          >
            Pay Now
          </button>
        )}
      </div>
      <small style={{ color: "red" }}>{cardError}</small>
      <small style={{ color: "green" }}>{success}</small>
      <div className="safe_wrp">
        <GoShieldCheck size={20} color="#30b130" />
        <BiSolidLock size={17} color="#30b130" />
        <small>100% Safe & Secure Payment</small>
      </div>
    </form>
  );
};

export default InstantPaymentForm;
